import React from "react";
import { motion } from "framer-motion";
import { MapPin, Instagram, Clock } from "lucide-react";

const ADDRESS_QUERY = encodeURIComponent(
  "Shop No 5, Cornelian Building 104, August Kranti Marg, Kemps Corner, Mumbai 400036, Maharashtra, India"
);

export const LocationContact = () => {
  return (
    <section
      id="visit"
      data-testid="visit-section"
      className="relative bg-cream py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-3 text-espresso/60 text-[12px] tracking-[0.3em] uppercase mb-5">
            <span className="h-px w-10 bg-espresso/40" />
            Visit Us
            <span className="h-px w-10 bg-espresso/40" />
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-espresso text-balance">
            Find us in <span className="italic">Kemps Corner.</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10">
          {/* Map */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-7 relative border border-espresso/15 overflow-hidden"
            data-testid="map-wrapper"
          >
            <iframe
              title="OROMA — Kemps Corner location map"
              data-testid="visit-map-iframe"
              src={`https://www.google.com/maps?q=${ADDRESS_QUERY}&output=embed`}
              width="100%"
              height="520"
              style={{ border: 0, filter: "grayscale(20%) contrast(0.95)" }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </motion.div>

          {/* Card */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="lg:col-span-5 bg-espresso text-cream p-10 lg:p-12 flex flex-col justify-between"
            data-testid="visit-card"
          >
            <div>
              <div className="flex items-center gap-3 text-gold text-[12px] tracking-[0.3em] uppercase">
                <MapPin size={14} />
                The address
              </div>
              <p
                className="mt-5 font-serif text-3xl lg:text-4xl leading-[1.2]"
                data-testid="visit-address"
              >
                Shop No 5, Cornelian Building 104,
                <br />
                August Kranti Marg,
                <br />
                Kemps Corner, Mumbai 400036
                <br />
                <span className="text-cream/70 text-2xl italic">Maharashtra, India</span>
              </p>

              <div className="mt-10 border-t border-cream/15 pt-8">
                <div className="flex items-center gap-3 text-gold text-[12px] tracking-[0.3em] uppercase">
                  <Clock size={14} />
                  Hours
                </div>
                <div className="mt-4 space-y-1 text-cream/85 text-[14px]" data-testid="visit-hours">
                  <p>Monday — Friday · 9:00 AM – 11:00 PM</p>
                  <p>Saturday — Sunday · 8:30 AM – 11:30 PM</p>
                </div>
              </div>
            </div>

            <div className="mt-12 flex flex-col sm:flex-row gap-4">
              <a
                href="https://www.instagram.com/oroma_bombay"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="visit-instagram-cta"
                className="inline-flex items-center justify-center gap-3 bg-gold text-espresso px-6 py-4 text-[11px] tracking-[0.28em] uppercase hover:bg-cream transition-colors duration-500"
              >
                <Instagram size={16} />
                @oroma_bombay
              </a>
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${ADDRESS_QUERY}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="visit-directions-cta"
                className="inline-flex items-center justify-center gap-3 border border-cream/40 text-cream px-6 py-4 text-[11px] tracking-[0.28em] uppercase hover:border-gold hover:text-gold transition-colors duration-500"
              >
                Get Directions
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
